// Diagnostic selection-trace ring buffer (Kimi spec, 2026-09-30 TH1 lane).
// Lightweight + SILENT in normal use: entries go to sessionStorage
// ['vecindus_sel_trace'], capped at the last ~50. console.info fires only
// when localStorage['vecindus_sel_trace_debug'] is set.
//
// DUMP (paste in the browser console):
//   console.table(JSON.parse(sessionStorage.getItem('vecindus_sel_trace')))
//   // or pretty:
//   JSON.parse(sessionStorage.getItem('vecindus_sel_trace')).forEach(e => console.info('[seltrace]', e))
//
// BUILD ROTATION (Jaime 2026-10-01 02:22): every entry is tagged with the
// build SHA it was captured on. When the persisted trace was written by a
// DIFFERENT build, it is cleared and replaced with a single 'resetFromBuild'
// marker — pasted traces must never mix events from two bundles.

export const SEL_TRACE_KEY = 'vecindus_sel_trace';

const CURRENT_BUILD_SHA = (typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'unknown') as string;

function traceBuildSha(entry: Record<string, unknown>): string {
  return typeof entry.buildSha === 'string' ? entry.buildSha : 'unknown';
}

/** One-time-per-boot rotation: drop a trace captured by a different build. */
function rotateOnBuildChange(): void {
  try {
    const raw = sessionStorage.getItem(SEL_TRACE_KEY);
    if (!raw) return;
    let arr: unknown[] = [];
    try { arr = JSON.parse(raw) as unknown[]; } catch { arr = []; }
    if (!Array.isArray(arr)) { sessionStorage.removeItem(SEL_TRACE_KEY); return; }
    const previous = arr.length > 0 && typeof arr[0] === 'object' && arr[0] !== null
      ? (arr[0] as Record<string, unknown>)
      : null;
    const previousSha = previous ? traceBuildSha(previous) : 'unknown';
    if (previousSha === CURRENT_BUILD_SHA) return;
    // The marker is tagged with the CURRENT buildSha so the next boot on the
    // same build recognizes it as same-build and does not rotate again.
    sessionStorage.setItem(SEL_TRACE_KEY, JSON.stringify([
      { t: Date.now(), ev: 'resetFromBuild', buildSha: CURRENT_BUILD_SHA, fromBuild: previousSha, toBuild: CURRENT_BUILD_SHA, dropped: arr.length },
    ]));
  } catch { /* storage optional */ }
}
rotateOnBuildChange();

export function traceSel(event: string, data?: Record<string, unknown>): void {
  try {
    const raw = sessionStorage.getItem(SEL_TRACE_KEY);
    const arr: unknown[] = raw ? JSON.parse(raw) : [];
    arr.push({ t: Date.now(), ev: event, buildSha: CURRENT_BUILD_SHA, ...(data || {}) });
    while (arr.length > 50) arr.shift();
    sessionStorage.setItem(SEL_TRACE_KEY, JSON.stringify(arr));
    if (typeof localStorage !== 'undefined' && localStorage.getItem('vecindus_sel_trace_debug')) {
      console.info('[seltrace]', event, data || {});
    }
  } catch { /* storage optional */ }
}
